<app-breadcrumb [master]="'Rozliczenia'" [parentName]="'Saldo'" [name]="'Lista'"></app-breadcrumb>
<div class="contract-balance-list-container" fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="row">
    <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm">

      <app-month-picker
        class="contract-balance-list-filter"
        label="Miesiąc rozliczeniowy" [required]="false"
        name="billingMonth" [(ngModel)]="initialFilters.billingMonth"
      ></app-month-picker>

      <app-dict-ofwcas
        [multiple]="false" label="OFWCA"
        class="contract-balance-list-filter"
        [(ngModel)]="initialFilters.ofwca" name="ofwca"
      ></app-dict-ofwcas>

      <app-dict-partners
        [multiple]="false" label="Partner"
        class="contract-balance-list-filter"
        [(ngModel)]="initialFilters.partner" name="partner"
      ></app-dict-partners>

      <mat-form-field class="contract-balance-list-filter">
        <mat-label>Numer umowy</mat-label>
        <input matInput placeholder="12345" name="number" [(ngModel)]="initialFilters.number">
      </mat-form-field>

      <app-dict
        [multiple]="false" [dictType]="'company'"
        [label]="'Firma'" class="contract-balance-list-filter"
        [(ngModel)]="initialFilters.company" name="company"
      ></app-dict>

      <app-dict
        [multiple]="true" [dictType]="'contract_type'"
        [label]="'Typ umowy'" class="contract-balance-list-filter"
        [(ngModel)]="initialFilters.contractType" name="contractType"
      ></app-dict>

      <app-dict
        [multiple]="true" label="Status umowy"
        class="contract-balance-list-filter"
        dictType="contract_status"
        [(ngModel)]="initialFilters.contractStatus" name="contractStatus"
      ></app-dict>

      <app-dict-regionals
        [multiple]="false" label="Regionalny (majątek)"
        class="contract-balance-list-filter"
        [(ngModel)]="initialFilters.assetsRegional" name="assetsRegional"
      ></app-dict-regionals>


      <mat-form-field class="contract-balance-list-filter">
        <mat-label>Kwota do wypłaty od</mat-label>
        <input matInput placeholder="Kwota do wypłaty od" name="gte$toPayNet" [(ngModel)]="initialFilters.gte$toPayNet">
      </mat-form-field>

      <mat-form-field class="contract-balance-list-filter">
        <mat-label>Kwota do wypłaty do</mat-label>
        <input matInput placeholder="Kwota do wypłaty do" name="lte$toPayNet" [(ngModel)]="initialFilters.lte$toPayNet">
      </mat-form-field>

      <mat-form-field class="contract-balance-list-filter">
        <mat-label>Kwota zapłacona </mat-label>
        <input matInput placeholder="Kwota zapłacona od" name="gte$paid" [(ngModel)]="initialFilters.gte$paid">
      </mat-form-field>

      <mat-form-field class="contract-balance-list-filter">
        <mat-label>Kwota zapłacona do</mat-label>
        <input matInput placeholder="Kwota zapłacona do" name="lte$paid" [(ngModel)]="initialFilters.lte$paid">
      </mat-form-field>


    </form>

  </div>
  <div fxLayout="row" fxLayoutGap="15px">
    <button *ngIf="(userPermissions | async).settlement.admin_root" (click)="downloadInvoiceReport()" [disabled]="!(userPermissions | async).settlement.admin_root"
            mat-raised-button class="report-button"><mat-icon>download</mat-icon> Pobierz raport zestawień prowizyjnych</button>
    <span fxFlex></span>
    <button *ngIf="(userPermissions | async).settlement.read_report" (click)="downloadReport()" [disabled]="!(userPermissions | async).settlement.read_report"
            mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>

  <div fxLayout="column">
    <table mat-table [dataSource]="items" matSort (matSortChange)="sortChanged($event)">

      <ng-container matColumnDef="number">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="number"> Numer umowy</th>
        <td mat-cell *matCellDef="let element">
          <a class="default-link" [routerLink]="['/rozliczenia/salda/szczegoly', element?.uuid]">
            {{element.contract.number}}
          </a>
        </td>
      </ng-container>

      <ng-container matColumnDef="company">
        <th mat-header-cell *matHeaderCellDef> Firma </th>
        <td mat-cell *matCellDef="let element">
          {{element.company.name}}
        </td>
      </ng-container>


      <ng-container matColumnDef="party">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="party"> Partner/OFWCA </th>
        <td mat-cell *matCellDef="let element" >
          <div class="statusChange-flex-container">

            <ng-container *ngIf="element.partner">
<!--              <a class="default-link" [routerLink]="['/partnerzy/szczegoly', element.partner?.uuid]">{{element.partner?.shortName}}</a>-->
              <a class="default-link" [routerLink]="['/rozliczenia/salda/szczegoly', element?.uuid]">{{element.partner?.shortName}}</a>
            </ng-container>

            <ng-container *ngIf="element.ofwca">
<!--              <a class="default-link" [routerLink]="['/ofwca/szczegoly', element.ofwca?.uuid]">{{element.ofwca.fullName}}</a>-->
              <a class="default-link" [routerLink]="['/rozliczenia/salda/szczegoly', element?.uuid]">{{element.ofwca.fullName}}</a>
            </ng-container>

          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="contractOwner">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="contractOwner"> Strona umowy </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.partner">
            Partner
          </ng-container>

          <ng-container *ngIf="element.ofwca">
            OFWCA
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef> Status umowy</th>
        <td mat-cell *matCellDef="let element">
          <button mat-raised-button [ngClass]="element.contract.status.color + '-button'">{{element.contract.status.name}}</button>
        </td>
      </ng-container>

      <ng-container matColumnDef="contractType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="contractType"> Typ umowy</th>
        <td mat-cell *matCellDef="let element">
          {{element.contractType.name}}
        </td>
      </ng-container>

      <ng-container matColumnDef="toPayNet" >
        <th mat-header-cell *matHeaderCellDef mat-sort-header="toPayNet"> Kwota do wypłacenia </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.toPayNet !== null">{{element.toPayNet | number:'1.2-2'}} zł</ng-container>
          <ng-container *ngIf="element.toPayNet === null">0.00 zł</ng-container>

        </td>
      </ng-container>
      <ng-container matColumnDef="paid" >
        <th mat-header-cell *matHeaderCellDef mat-sort-header="paid"> Kwota zapłacona </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.paid !== null">{{element.paid | number:'1.2-2'}} zł</ng-container>
          <ng-container *ngIf="element.paid === null">0.00 zł</ng-container>
        </td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
  </div>

</div>
